import { Flex, Skeleton } from 'antd';
import styles from './index.module.less';
import { HomeGPTsModel } from '@/types/home';
import Link from 'next/link';
import { useRouter } from 'next/router';
import _ from 'lodash';
import { getPathTitle, imgUrl } from '@/shared/utils';
import useScreenSize from '@/lib/hooks/utils/useScreenSize';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

const GPTsItemList = ({ dataList, style }: { dataList?: HomeGPTsModel[]; style?: {} }) => {
  const router = useRouter();
  const { width } = useScreenSize();
  const { t } = useTranslation();

  const topStyle = () => {
    if (width >= 768) {
      return { padding: 20 };
    } else {
      return { padding: `20px 0`, borderTop: `1px solid var(--app-line-bg-rgb)` };
    }
  };

  const onClick = (item?: HomeGPTsModel) => {
    if (item?.gpts_id == undefined) {
      return;
    }
    // router.push(`/gpts/${item?.gpts_id}`)
    router.push(`/gpts/${item?.gpts_id}/${getPathTitle(item?.title)}`);
  };

  function createItem(index: number, item?: HomeGPTsModel) {
    return (
      <Flex className={styles.flexItem} key={index} onClick={() => onClick(item)}>
        {/* <span className={styles.indexItem}> {index + 1} </span> */}
        {/* <img className={styles.imgItem} src={imgUrl(item?.logo, "small")} loading="lazy" /> */}

        <Image
          src={imgUrl(item?.logo, 'small')}
          width={40}
          height={40}
          alt={item?.title}
          loading="lazy"
          className={styles.imgItem}
        />

        <div className={styles.titleContainer}>
          <Link href={`/gpts/${item?.gpts_id}/${getPathTitle(item?.title)}`}>
            <div className={styles.titleItem}>{item?.title}</div>
          </Link>
          <span className={styles.descItem}> {item?.description} </span>
        </div>
      </Flex>
    );
  }

  const emptyItem = () => (
    <Flex className={styles.flexItem}>
      <Skeleton.Avatar active className={styles.imgItem} />
      <Skeleton.Input active size={'small'} />
    </Flex>
  );

  return (
    <div className={styles.mainContainer} style={{ ...topStyle(), ...style }}>
      <h3>{t('relatedGPTsForYou')}</h3>

      {_.isEmpty(dataList) ? (
        <>
          {emptyItem()}
          {emptyItem()}
        </>
      ) : (
        <>
          {(dataList ?? []).map((item, index) => {
            return createItem(index, item);
          })}
        </>
      )}

      <Link href={'/gpts'}>{`${t('moreGPTs')} >`}</Link>
    </div>
  );
};

export default GPTsItemList;
